import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Grid, Button } from "@material-ui/core";
import { searchItems } from "services/api/si180Api";

const Autocomplete = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [searchResult, setSearchResult] = useState([]);
  const history = useHistory();

  // Mock data for suggestions; replace with your data source
  //   const allSuggestions = [
  //     "Lunch->Apple",
  //     "Breakfast->Banana",
  //     "Cherry",
  //     "Dinner->Date",
  //     "Elderberry",
  //   ];

  useEffect(() => {
    const fetchData = async () => {
      if (searchQuery !== "" && searchQuery.length > 2) {
        try {
          const result = await searchItems(searchQuery); // Call the async function and wait for the result

          if (result) {
            // Flatten the array after mapping to handle multiple MenuNames or ensure at least one record per item
            const formattedResult = result.flatMap((obj) => {
              // Handle cases where MenuName might be empty or null
              const menuNames = obj.MenuName
                ? obj.MenuName.split(",").map((menu) => menu.trim())
                : ["No menu specified"];

              return menuNames.map((menu) => ({
                ItemName: obj.ItemName,
                MenuName: menu, // Use trimmed or default menu name
                Department: obj.Department.trim(), // Trim to remove any excess whitespace
              }));
            });
            setSearchResult(formattedResult); // Set the search result state
          }
        } catch (error) {
          console.error("Failed to fetch search results:", error);
          // Handle errors, e.g., by setting an error state or alerting the user
        }
      } else {
        setSearchResult([]); // Clear the result if the search query is empty
      }
    };

    fetchData(); // Invoke the async function defined above
  }, [searchQuery]);

  const handleSearchChange = (event) => {
    setSuggestions([]);
    const value = event.target.value;

    setSearchQuery(value);

    if (value.length > 0 && searchResult?.length > 0) {
      //   const filteredSuggestions = searchResult?.filter((suggestion) =>
      //     suggestion.toLowerCase().includes(value.toLowerCase())
      //   );

      setSuggestions(searchResult);
    } else {
      setSuggestions([]);
    }
  };

  return (
    <Grid container spacing={1} alignItems="center">
      <Grid item>
        <input
          className="autoBtn"
          type="text"
          placeholder="Search all items..."
          value={searchQuery}
          onChange={handleSearchChange}
        />
        {suggestions.length > 0 && (
          <ul className="autocomplete-suggestions">
            {suggestions.map((suggestion, index) => (
              <li
                key={index}
                onClick={() => {
                  setSearchQuery(suggestion.ItemName);
                  sessionStorage.setItem("selectedMenu", suggestion.MenuName);
                  sessionStorage.setItem(
                    "selectedCategory",
                    suggestion.Department
                  );
                  setSuggestions([]);
                  history.replace("/resident-items", {
                    searchedItem: suggestion.ItemName,
                  });
                }}
              >
                {suggestion.MenuName || "No menu specified"} {"->"}
                {suggestion.Department} {"->"}
                {suggestion.ItemName}
              </li>
            ))}
          </ul>
        )}
      </Grid>
      <Grid item>
        <Button
          className="si180btnClear"
          color="secondary"
          onClick={() => {
            setSearchQuery("");
            setSuggestions([]);
          }}
        >
          Clear
        </Button>
      </Grid>
    </Grid>
  );
};

export default Autocomplete;
